export const Roles = {
  ADMIN: 'Admin',
  SHIPPER: 'Embarcador',
  OPERATOR: 'Operador'
};
